<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
 	  <el-form :inline="true" class="demo-form-inline backborder1" size="small">
          <el-form-item v-if="actionauth.base_customer_cate_add=='true'">
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="createClassDialog = true">新增客户分类</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="classlists" style="width: 100%">
	          <el-table-column label="客户分类名称" prop="groupname"></el-table-column>
	          <el-table-column prop="discount" label="折扣（%）" width="100" align="center">
	              <template slot-scope="scope">
	                  <el-input size="small" v-model="typelists[scope.$index]"  @blur="changerate(scope.$index,scope.row)"></el-input>
	              </template slot-scope="scope">
	          </el-table-column>
	            
	          <el-table-column prop="istype" label="折扣/商品会员价（折扣方式）" width="125" align="center">
	          	  <template slot-scope="scope">
	              	  <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="istype[scope.$index]"  @change="changedistype(scope.$index,scope.row)"></el-switch>
	          	  </template>
	          </el-table-column>
	            
	          <el-table-column label="操作" width="160" v-if="actionauth.base_customer_cate_edit=='true' || actionauth.base_customer_cate_del=='true'" align="center">
	              <template slot-scope="scope">
	                  <el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editClassDialog(scope.row)" v-if="actionauth.base_customer_cate_edit=='true'"></el-button>
	                  <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delClass(scope.row)" v-if="actionauth.base_customer_cate_del=='true'"></el-button>
	              </template>
	          </el-table-column>
          </el-table>
      </div>
      
      <!------------------------add class---------------------->
        <el-dialog title="新增客户分类" :visible.sync="createClassDialog" width="30%">
          <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="small">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="createclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="createClassDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add class end---------------------->
      
      <!------------------------edit class---------------------->
      <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
          <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="small">
              <el-col :span="22">
	              <el-form-item label="分类名称" prop="groupname">
	                <el-input v-model="updateclass.groupname"></el-input>
	              </el-form-item>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="updateClassDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------edit class end---------------------->
      
      
      
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      classlists:[],
      typelists:[],
      istype:[],
      classListLoading:false,
      createClassDialog:false,
      createclass: {
          act:'addclass',
          token:this.$cookies.get('token'),
          groupname:'',
      },
      classrules: {
          groupname: [
              { required: true, message: '请输入分类名称', trigger: 'blur' },
              { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
          ]
      },
      updateClassDialog:false,
      updateclass: {
          act:'editclass',
          token:this.$cookies.get('token'),
          id:'',
          groupname:'',
      },
      updateClassLoading:false,
      createClassLoading:false,
      
    }
  },
  mounted(){
      this.getactionauth();
      this.getClassList(); //获取分类信息
      
  },
  methods:{  
  	//重置表单
    reset() {
        this.$refs.create.resetFields();
    },
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 分类信息列表 **/
    getClassList(){
      this.classListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getclass',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.classListLoading = false;
        }else{
          this.classlists = JSON.parse(Base64.decode(res.data.Data));          
          var _this=this;
          this.classlists.forEach(function(e,index){  
          	  e.istype==0 ? _this.istype.splice(index,1,false) : _this.istype.splice(index,1,true);
          	  _this.typelists.splice(index,1,e.discount);
          });           
          this.classListLoading = false;
        }
      }).catch((res) => {
          this.classListLoading=false;
      });
    },
    
    /** 修改折扣 **/
    changerate(index,item) {
    	var rate=this.typelists[index];   	
    	var resource = this.$resource(this.url);
        resource.save({act:'changerete',id:item.id,rate:rate,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            
        });
    },
    
    /** 选择折扣方式(打折/商品会员价) **/
    changedistype(index,obj) {
    	var isdiscount=0;
    	this.istype[index] ? isdiscount=1 : isdiscount=0;
		
        var resource = this.$resource(this.url);
        resource.save({act:'changerebate',id:obj.id,isdiscount:isdiscount,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 新增分类 **/
    createClassSave(){
        // 主动校验
        this.$refs.createclass.validate((valid) => {
      	    if(!valid) return false;

            this.createClassLoading=true;
            var resource = this.$resource(this.url);
            resource.save(this.createclass).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.createClassLoading=false;
                }else{
                    this.$message.success(res.data.Message);
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                    this.getClassList();
                }
            }).catch((res) => {
                this.createClassDialog=false;
                this.createClassLoading=false;
            });
        });
    },
    
    /** 获取客户分类信息 **/
    editClassDialog(item){
      this.updateClassDialog=true;
      this.updateclass.id=item.id;
      this.updateclass.groupname=item.groupname;
    },
    
    
    //编辑分类的保存
    updateClassSave(){
        // 主动校验
        this.$refs.updateclass.validate((valid) => {
        	if(!valid) return false;        
            this.updateClassLoading=true;
            var resource = this.$resource(this.url);
            resource.save(this.updateclass).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateClassLoading=false;
                }else{
                    this.$message.success(res.data.Message);
                    this.updateClassDialog=false;
                    this.updateClassLoading=false;
                    this.getClassList();
                }
            }).catch((res) => {
                this.createClassDialog=false;
                this.createClassLoading=false;
            });

        });
    },
    
    /** 删除 **/
    delClass(item){
        this.$confirm('此操作将永久删除 ' + item.groupname + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
            // 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'delclass',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('成功删除了' + item.groupname + '!');
                    this.getClassList();
                }
            }).catch((res) => {
                
            });
        }).catch(() => {
        
        });
    },     
    
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Customercate.vue